import Honeybadger from '@honeybadger-io/js';
export { default as Honeybadger } from '@honeybadger-io/js';
import React, { Component } from 'react';

function DefaultErrorComponent({ error, info }) {
    return (React.createElement("div", { className: 'error' },
        React.createElement("div", null, "An Error Occurred"),
        React.createElement("div", null, error ? error.toString() : ''),
        React.createElement("div", null, info ? JSON.stringify(info, null, 2) : '')));
}

class HoneybadgerErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            info: null,
            errorOccurred: false
        };
    }
    static getDerivedStateFromError(error) {
        return { error: error, errorOccurred: true, info: null };
    }
    componentDidMount() {
        this.props.honeybadger.afterNotify((error, _notice) => {
            if (!error && this.props.showUserFeedbackFormOnError) {
                this.props.honeybadger.showUserFeedbackForm();
            }
        });
    }
    componentDidCatch(error, errorInfo) {
        this.setState({ error, info: errorInfo });
        this.props.honeybadger.notify(error, { context: errorInfo });
    }
    getErrorComponent() {
        return this.props.ErrorComponent
            ? React.createElement(this.props.ErrorComponent, { ...this.state })
            : React.createElement(DefaultErrorComponent, { ...this.state });
    }
    render() {
        return (React.createElement(React.Fragment, null, this.state.errorOccurred
            ? this.getErrorComponent()
            : this.props.children));
    }
}
HoneybadgerErrorBoundary.defaultProps = {
    showUserFeedbackFormOnError: false
};

const NOTIFIER = {
    name: '@honeybadger-io/react',
    url: 'https://github.com/honeybadger-io/honeybadger-js/tree/master/packages/react',
    version: '6.1.27'
};
Honeybadger.setNotifier(NOTIFIER);

export { HoneybadgerErrorBoundary };
//# sourceMappingURL=honeybadger-react.esm.js.map
